import { Server } from './Server';

const observers = [];
let ticker = 0;
let intervalId = 0;

const updateTicker = async () => {
  try {
    ticker = await Server.getCurrentTicker();
    observers.forEach(callback => {
      callback(ticker);
    });
  } catch {
    // Fail silently
  }
};

function startInterval() {
  intervalId = setInterval(updateTicker, 60000);
}

export default function observeTickerChanges(callback) {
  if (intervalId === 0) {
    startInterval(callback);
  }
  observers.push(callback);
  updateTicker();
}
